import React, { Component } from "react";
import "./LogInMail.css";
import "./Home.css";
import "./RegistrationFormComponents/registrationForm.css";
import Modal from "react-modal";
import GenerateNewOTPComponent from "./GenerateNewOTPComponent";
import ForgottenPassword from "./../components/forgottenPassword/ForgottenPassword";
import ChangePassword from "./../components/forgottenPassword/ChangePassword";
import ChangePasswordByUser from "./../components/forgottenPassword/ChangePasswordByUser";
import Loader from "./../components/Loader";
import ReCAPTCHA from "react-google-recaptcha";
import RegistrationFormDialog from "./RegistrationFormComponents/RegistrationFormDialog";
import Axios from "axios";
import RegistrationInfoDialog from "./RegistrationFormComponents/RegistrationInfoDialog";
import ClubRegistrationLanguageComponent from "./RegistrationFormComponents/ClubRegistrationLanguageComponent";
import RegistrationInfoFailureDialog from "./RegistrationFormComponents/RegistrationInfoFailureDialog";
var currentURL = window.location.href;
var oldURL = "";

Modal.setAppElement("body");
class LoginMailComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      code: "",
      stage: 1,
      errorOTP: "",
      error: "",
      valueOfGenerateOTP: false,
      labelName: "sportOauthLabel.insertOtp",
      authServerUrl: "",
      imageData: "",
      backgroundImage: "",
      watermarkImage: "",
      imageType: "jpeg",
      backgroundImageType: "jpeg",
      watermarkImageType: "jpeg",
      userBeforeLoggedIn: null,
      passwordChangeRequired: false,
      userWhoWantsToChangePassword: null,
      newUserChangePassword: false,
      connectedUsers: false,
      clicked: false,
      // loading: false,
      loadingCheckOtp: false,
      loadingSendOtp: false,
      showModal: false,
      logoBottomImage: "",
      logoBottomImageType: "jpeg",
      luxTrustPageLabelBottom: "",
      showRegistrationDialog: false,
      countries: [],
      languages: [],
      clubs: [],
      clubSeasons: [],
      showRegistrationSuccessInfo: false,
      labelNamesList: [],
      reCapchaKey: "",
      showRegistrationFailureInfo: false,
      registerErrorResponse: "",
      isOtpRequired: false,
      showOtpField: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitCode = this.handleSubmitCode.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeValueState = this.changeValueState.bind(this);
    this.handleChangeCode = this.handleChangeCode.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setNewUserChangePassword = this.setNewUserChangePassword.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.checkURLchange = this.checkURLchange.bind(this);
    this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
    this.onRegisterTabBtnClick = this.onRegisterTabBtnClick.bind(this);
    this.onLoginTabBtnClick = this.onLoginTabBtnClick.bind(this);
    this.recaptchaValue = null;
    this.onRegisterBtnClick = this.onRegisterBtnClick.bind(this);
    this.closeRegistrationModal = this.closeRegistrationModal.bind(this);
    this.dataForRegistrationLoaded = false;
    this.loadDataForRegistration = this.loadDataForRegistration.bind(this);
    this.showRegistrationSuccessInfo =
      this.showRegistrationSuccessInfo.bind(this);
    this.closeRegistrationInfoModal =
      this.closeRegistrationInfoModal.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.loadLabels = this.loadLabels.bind(this);
    this.composingLabel = this.composingLabel.bind(this);
    this.getRecapchaKey = this.getRecapchaKey.bind(this);
    this.ResourceServerBaseUrl = "";
    this.showRegistrationFailureInfo =
      this.showRegistrationFailureInfo.bind(this);
    this.getResourceServerBaseUrl = this.getResourceServerBaseUrl.bind(this);
    this.handleCheckUserName = this.handleCheckUserName.bind(this);
  }

  checkURLchange(currentURL) {
    if (currentURL != oldURL) {
      oldURL = currentURL;
    }

    oldURL = window.location.href;
    var substring = "/two_factor_authentication";
    oldURL = oldURL.substring(0, oldURL.indexOf("#"));
    if (oldURL.includes(substring)) {
      this.setState({
        stage: 2,
      });
    }
  }

  componentDidMount() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function (event) {
      window.history.go(1);
    };
    this.loadAuthorizationServerUrl();
    this.getImage();
    this.checkURLchange(currentURL);
    this.onLoginTabBtnClick();
    this.loadLabels("EN");
    this.getRecapchaKey();
    this.getResourceServerBaseUrl();
  }

  getOtpRequired(username) {
    Axios({
      method: "GET",
      url: "user/optRequired",
      params: {
        username: username,
      },
    }).then((response) => {
      console.log("optRequired", response.data.otpRequired);
      if (response.status === 200) {
        this.setState({
          isOtpRequired: response.data.otpRequired,
        });
      }
    });
  }

  getRecapchaKey() {
    Axios({
      method: "POST",
      url: "config/getConfig",
      params: {
        name: "reCapchaKey",
      },
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        this.setState({
          reCapchaKey: response.data.value,
        });
      }
    });
  }
  loadLabels(languageCode) {
    Axios({
      method: "POST",
      url: "labelname/listAllByPrefix",
      params: {
        code: languageCode,
        labelprefix: "sportOauthLabel.",
      },
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        let list = [];
        response.data.forEach((element) => {
          list[element.labelId] = element.name;
        });
        this.setState({
          labelNamesList: list,
        });
      }
    });
  }
  getResourceServerBaseUrl() {
    Axios({
      method: "POST",
      url: "config/getConfig",
      params: {
        name: "ResourceServerBaseUrl",
      },
    }).then((response) => {
      this.ResourceServerBaseUrl = response.data;
      localStorage.setItem("ResourceServerBaseUrl", response.data.value);
    });
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }
  setNewUserChangePassword() {
    this.setState({
      userWhoWantsToChangePassword: null,
      newUserChangePassword: false,
      password: "",
    });
  }

  handleClick() {
    this.setState({
      clicked: true,
      passwordChangeRequired: false,
    });
  }

  getImage() {
    fetch("config/getImage?name=LuxTrustPageLogo", {
      method: "POST",
    })
      .then((response) => {
        fetch("config/getImage?name=LuxTrustPageBackGround", {
          method: "POST",
        })
          .then((response) => {
            fetch("config/getImage?name=LuxTrustPageWatermark", {
              method: "POST",
            })
              .then((resp) => {
                fetch("config/getImage?name=LuxTrustPageLogoBottom", {
                  method: "POST",
                })
                  .then((respon) => {
                    fetch("config/getImage?name=LuxTrustPageLabelBottom", {
                      method: "POST",
                    })
                      .then((respon) => {
                        return respon.json();
                      })
                      .then((data) => {
                        this.setState({
                          luxTrustPageLabelBottom: data.value,
                        });
                      });
                    return respon.json();
                  })
                  .then((data) => {
                    this.setState({
                      logoBottomImage: data.image,
                      logoBottomImageType: data.value,
                    });
                  });
                return resp.json();
              })
              .then((data) => {
                this.setState({
                  watermarkImage: data.image,
                  watermarkImageType: data.value,
                });
              });
            return response.json();
          })
          .then((data) => {
            this.setState({
              backgroundImage: data.image,
              backgroundImageType: data.value,
            });
          });
        return response.json();
      })
      .then((data) => {
        this.setState({
          imageData: data.image,
          imageType: data.value,
        });
      });
  }
  loadAuthorizationServerUrl() {
    fetch("server/url?serverName=AuthorizationServer", {
      method: "POST",
    })
      .then((result) => {
        return result.json();
      })
      .then((data) => {
        this.setState({
          authServerUrl: data.value,
        });
      });
  }

  handleChange(event) {
    const { value, name } = event.target;
    this.setState({ [name]: value });
  }

  handleChangeCode(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }

  handleSubmitCode(event) {
    var parent = this;
    var self = this;
    let bodyData = "code=" + this.state.code;
    event.preventDefault();
    this.setState({
      loadingCheckOtp: true,
      showModal: true,
    });
    fetch(this.state.authServerUrl + "two_factor_authentication", {
      method: "POST",
      redirect: "follow",
      headers: new Headers({
        Accept:
          "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: bodyData,
      credentials: "include",
    })
      .then(function (response) {
        self.setState({
          loadingCheckOtp: false,
        });
        console.log("RESPONSE", response);
        if (response.status === 404) {
          self.setState({
            valueOfGenerateOTP: true,
            labelName: "sportOauthLabel.otpExpiredClickForNew",
            errorOTP: "",
            code: "",
          });
        } else if (response.status === 400) {
          window.location.href = self.state.authServerUrl + "oauth/error";
        } else {
          if (!response.ok) {
            console.log("this one is NOT good: ", response.url);
            parent.setState({
              errorOTP: "sportOauthLabel.wrongOtp",
              labelName: "sportOauthLabel.insertOtp",
            });
            console.log(parent.state.errorOTP);
            parent.renderStageCode();
          } else {
            fetch(
              "userupdate/updateConnectionDate?username=" +
                parent.state.username,
              {
                method: "GET",
                credentials: "include",
                redirect: "follow",
              }
            ).then((result) => {
              window.location.href = response.url;
            });
          }
        }
      })
      .catch((err) => console.error("Caught error: ", err));
    console.log("stage is " + this.state.stage);
  }

  handleCheckUserName(event) {
    event.preventDefault();
    Axios({
      method: "GET",
      url: "user/optRequired",
      params: {
        username: this.state.username,
      },
    }).then((response) => {
      console.log("optRequired", response.data.otpRequired);
      if (response.status === 200) {
        this.setState({
          error: "",
          isOtpRequired: response.data.otpRequired,
          stage: 2,
        });
      } else {
        this.setState({ error: "Wrong username!" });
        this.renderAuthentication();
      }
    });
  }

  handleSubmit(event) {
    var parent = this;

    let bodyData =
      "username=" +
      this.state.username +
      "&password=" +
      this.state.password +
      "&dbParam=true";

    event.preventDefault();
    console.log("stage is " + this.state.stage);
    let self = this;
    if (this.state.isOtpRequired === true) {
      this.setState({
        loadingSendOtp: true,
        showModal: true,
      });
    }

    fetch(
      "changePasswordRequired?username=" +
        this.state.username +
        "&password=" +
        this.state.password,
      {
        method: "POST",
      }
    )
      .then((result) => {
        return result.json();
      })
      .then((data) => {
        if (data["status"] !== "DS" && data["status"] !== "P") {
          this.setState({
            passwordChangeRequired: data["changePasswordRequired"],
            userWhoWantsToChangePassword: data,
          });
          if (!this.state.passwordChangeRequired) {
            fetch("maxNumberOfUsers", {
              method: "POST",
            })
              .then((result) => {
                return result.json();
              })
              .then((data) => {
                this.setState({ connectedUsers: data });
                if (this.state.connectedUsers) {
                  fetch(this.state.authServerUrl, {
                    method: "POST",
                    redirect: "follow",
                    headers: new Headers({
                      Accept:
                        "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                      "Content-Type": "application/x-www-form-urlencoded",
                    }),
                    body: bodyData,
                    credentials: "include",
                  })
                    .then(function (response) {
                      self.setState({
                        loadingSendOtp: false,
                        showModal: false,
                      });
                      let errorUrl = self.state.authServerUrl + "?error";
                      console.log("ERROR URL: ", errorUrl);
                      if (response.url === errorUrl) {
                        console.log(
                          "Wrong  username or password " + response.url
                        );
                        parent.setState({ error: "Wrong password!" });
                        parent.renderAuthentication();
                      } else {
                        parent.setState({ error: "" });
                        console.log("OK  username or password " + response.url);
                        if (self.state.isOtpRequired === true) {
                          parent.setState({
                            showOtpField: true,
                          });
                        } else {
                          fetch(
                            "userupdate/updateConnectionDate?username=" +
                              parent.state.username,
                            {
                              method: "GET",
                              credentials: "include",
                              redirect: "follow",
                            }
                          ).then((result) => {
                            window.location.href = response.url;
                          });
                        }
                      }
                    })
                    .catch((err) => console.error("Caught error: ", err));
                  console.log("stage is " + this.state.stage);
                } else {
                  parent.setState({
                    error: "Max number of users is reached!",
                    loadingSendOtp: false,
                    showModal: false,
                  });
                }
              });
          } else {
            parent.setState({
              loadingSendOtp: false,
              showModal: false,
            });
            if (
              data["newUserChangePassword"] === true &&
              data["changePasswordRequired"]
            ) {
              if (data["passwordIsGood"] === true) {
                this.setState({
                  newUserChangePassword: data["newUserChangePassword"],
                  userWhoWantsToChangePassword: data,
                  passwordChangeRequired: false,
                  loadingSendOtp: false,
                  showModal: false,
                });
              } else {
                this.setState({
                  passwordChangeRequired: false,
                  loadingSendOtp: false,
                  showModal: false,
                });
                parent.setState({
                  error: "Wrong password",
                  loadingSendOtp: false,
                  showModal: false,
                });
              }
            }
          }
        } else {
          parent.setState({
            error:
              data["status"] === "DS"
                ? "User is disabled"
                : "User is pending" + " and can't log in.",
            loadingSendOtp: false,
            showModal: false,
          });
        }
      });
  }

  onRegisterTabBtnClick() {
    try {
      let registerSegment = document.getElementsByClassName(
        "registrationSideEmail"
      );
      if (
        registerSegment &&
        registerSegment[0].classList.contains("registrationSideEmailHiden")
      ) {
        registerSegment[0].classList.remove("registrationSideEmailHiden");
      }
      let loginSegment = document.getElementsByClassName("loginSideEmail");
      if (
        loginSegment &&
        !loginSegment[0].classList.contains("loginSideEmailHiden")
      ) {
        loginSegment[0].classList.add("loginSideEmailHiden");
      }

      let loginButton = document.getElementById("loginTabButton");
      if (loginButton && loginButton.classList.contains("activeBtn")) {
        loginButton.classList.remove("activeBtn");
      }

      let registerButton = document.getElementById("registerTabButton");
      if (registerButton && !registerButton.classList.contains("activeBtn")) {
        registerButton.classList.add("activeBtn");
      }
    } catch (error) {}
  }
  onLoginTabBtnClick() {
    try {
      let registerSegment = document.getElementsByClassName(
        "registrationSideEmail"
      );
      if (
        registerSegment &&
        !registerSegment[0].classList.contains("registrationSideEmailHiden")
      ) {
        registerSegment[0].classList.add("registrationSideEmailHiden");
      }
      let loginSegment = document.getElementsByClassName("loginSideEmail");
      if (
        loginSegment &&
        loginSegment[0].classList.contains("loginSideEmailHiden")
      ) {
        loginSegment[0].classList.remove("loginSideEmailHiden");
      }

      let loginButton = document.getElementById("loginTabButton");
      if (loginButton && !loginButton.classList.contains("activeBtn")) {
        loginButton.classList.add("activeBtn");
      }

      let registerButton = document.getElementById("registerTabButton");
      if (registerButton && registerButton.classList.contains("activeBtn")) {
        registerButton.classList.remove("activeBtn");
      }
    } catch (error) {}
  }

  onRecaptchaChange(value) {
    this.recaptchaValue = value;
  }

  onRegisterBtnClick() {
    if (this.recaptchaValue) {
      this.loadDataForRegistration("EN");
      this.setState({
        showRegistrationDialog: true,
      });
    }
  }

  loadDataForRegistration(languageCode) {
    if (this.dataForRegistrationLoaded === false) {
      let countries = [];
      let languages = [];
      let clubs = [];
      let clubSeasons = [];
      Axios({
        method: "POST",
        url: "countries/listActive",
        params: {
          code: languageCode,
        },
      }).then((countryResponse) => {
        if (countryResponse.status === 200) {
          countries = countryResponse.data;
        }
        console.log(countryResponse);
        Axios({
          method: "POST",
          url: "languages/listActive",
          params: {
            code: languageCode,
          },
        })
          .then((languageResponse) => {
            console.log(languageResponse);
            if (languageResponse.status === 200) {
              languages = languageResponse.data;
            }
            Axios({
              method: "POST",
              url: "clubs/listActive",
            })
              .then((clubResponse) => {
                console.log(clubResponse);
                if (clubResponse.status === 200) {
                  clubs = clubResponse.data;
                }
                Axios({
                  method: "POST",
                  url:
                    this.ResourceServerBaseUrl.value +
                    "/public/clubseason/listAll.do",
                })
                  .then((clubSeasonsResponse) => {
                    console.log(clubSeasonsResponse);
                    if (clubSeasonsResponse.status === 200) {
                      clubSeasons = clubSeasonsResponse.data;
                    }
                    this.setState({
                      countries: countries,
                      languages: languages,
                      clubs: clubs,
                      clubSeasons: clubSeasons,
                    });
                    this.dataForRegistrationLoaded = true;
                  })
                  .catch((error) => {
                    this.setState({
                      countries: countries,
                      languages: languages,
                      clubs: clubs,
                      clubSeasons: clubSeasons,
                    });
                  });
              })
              .catch((error) => {
                this.setState({
                  countries: countries,
                  languages: languages,
                  clubs: clubs,
                  clubSeasons: clubSeasons,
                });
              });
          })
          .catch((error) => {
            this.setState({
              countries: countries,
              languages: languages,
              clubs: clubs,
              clubSeasons: clubSeasons,
            });
          });
      });
    } else {
      this.setState({
        countries: this.state.countries,
        languages: this.state.languages,
        clubs: this.state.clubs,
      });
    }
  }
  closeRegistrationModal() {
    this.setState({
      showRegistrationDialog: false,
    });
  }
  showRegistrationSuccessInfo() {
    const me = this;
    this.setState(
      {
        showRegistrationSuccessInfo: true,
      },
      function () {
        setTimeout(function () {
          if (me.state.showRegistrationSuccessInfo === true) {
            me.setState({ showRegistrationSuccessInfo: false });
          }
        }, 6000);
      }
    );
  }
  closeRegistrationInfoModal() {
    const me = this;

    if (me.state.showRegistrationSuccessInfo === true) {
      me.setState({ showRegistrationSuccessInfo: false });
    }
  }
  handleLanguageChange(e) {
    this.dataForRegistrationLoaded = false;
    this.loadDataForRegistration(e.target.value);
    this.loadLabels(e.target.value);
  }

  composingLabel(labelId, defaultLabel, hideDots) {
    let dontShowDots = hideDots !== undefined ? hideDots : true;
    let label = defaultLabel;
    if (this.state.labelNamesList && this.state.labelNamesList[labelId]) {
      label = this.state.labelNamesList[labelId];
    }
    if (dontShowDots === false) {
      label = label + ": ";
    }
    return label;
  }

  showRegistrationFailureInfo(error) {
    const me = this;
    this.setState(
      {
        showRegistrationFailureInfo: true,
        registerErrorResponse: error.response,
      },
      function () {
        setTimeout(function () {
          if (me.state.showRegistrationFailureInfo === true) {
            me.setState({ showRegistrationFailureInfo: false });
          }
        }, 6000);
      }
    );
  }
  renderAuthentication() {
    const logoType =
      this.state.imageType !== "" ? this.state.imageType : "jpeg";
    const backgroundType =
      this.state.backgroundImageType !== ""
        ? this.state.backgroundImageType
        : "jpeg";
    const watermarkType =
      this.state.watermarkImageType !== ""
        ? this.state.watermarkImageType
        : "jpeg";
    const logoBottomImageType =
      this.state.logoBottomImageType !== ""
        ? this.state.logoBottomImageType
        : "jpeg";

    const logo64Image = `data:image/${logoType};base64,` + this.state.imageData;
    const background64Image =
      `data:image/${backgroundType};base64,` + this.state.backgroundImage;
    const base64WatermarkImg =
      `data:image/${watermarkType};base64,` + this.state.watermarkImage;
    const logoBottomImage =
      `data:image/${logoBottomImageType};base64,` + this.state.logoBottomImage;

    return (
      <div
        className="twoFactorAuthenticationContainer"
        style={{ backgroundImage: "url(" + base64WatermarkImg + ")" }}>
        <img src={logo64Image} className="luxtrustLogoContainer" />
        <ClubRegistrationLanguageComponent
          composingLabel={this.composingLabel}
          handleLanguageChange={this.handleLanguageChange}
        />
        <div className="loginSegmentEmail">
          <div className="tabBarSegment">
            <button
              onClick={() => this.onRegisterTabBtnClick()}
              className="tabBtn registerTabButton"
              id="registerTabButton">
              {this.composingLabel("sportOauthLabel.signUp", "Sign up")}
            </button>
            <button
              onClick={() => this.onLoginTabBtnClick()}
              className="tabBtn loginTabButton"
              id="loginTabButton">
              {this.composingLabel("sportOauthLabel.logIn", "Log in")}
            </button>
          </div>
          <div className="registrationSideEmail">
            {this.state.reCapchaKey !== "" && (
              <ReCAPTCHA
                className="captcha"
                ref={(recaptchaComp) => (this.recaptchaComp = recaptchaComp)}
                sitekey={this.state.reCapchaKey}
                size="compact"
                onChange={(val) => this.onRecaptchaChange(val)}
              />
            )}
            <button
              className="registerBtn"
              onClick={() => this.onRegisterBtnClick()}>
              {this.composingLabel("sportOauthLabel.register", "Register")}
            </button>
            <Modal
              className={"registrationModal"}
              overlayClassName="Overlay registrationDialogOverlay"
              isOpen={this.state.showRegistrationDialog}>
              <RegistrationFormDialog
                closeModal={this.closeRegistrationModal}
                showRegistrationSuccessInfo={this.showRegistrationSuccessInfo}
                showRegistrationFailureInfo={this.showRegistrationFailureInfo}
                countries={this.state.countries}
                languages={this.state.languages}
                clubs={this.state.clubs}
                clubSeasons={this.state.clubSeasons}
                composingLabel={this.composingLabel}
                checkUserExists={this.checkUserExists}
              />
            </Modal>
            <Modal
              className={"registrationInfoModal"}
              overlayClassName="Overlay registrationDialogOverlay"
              isOpen={this.state.showRegistrationSuccessInfo}>
              <RegistrationInfoDialog
                closeModal={this.closeRegistrationInfoModal}
                composingLabel={this.composingLabel}
              />
            </Modal>
            <Modal
              className={"registrationInfoModal"}
              overlayClassName="Overlay registrationDialogOverlay"
              isOpen={this.state.showRegistrationFailureInfo}>
              <RegistrationInfoFailureDialog
                closeModal={this.closeRegistrationInfoModal}
                composingLabel={this.composingLabel}
                registerErrorResponse={this.state.registerErrorResponse}
              />
            </Modal>
          </div>
          <div className="loginSideEmail">
            <p className="loginParagraphEmail">{this.state.error}</p>
            <form onSubmit={this.handleCheckUserName}>
              <input
                autoFocus={true}
                className="inputFieldEmail"
                name="username"
                type="text"
                value={this.state.username}
                onChange={this.handleChange}
                placeholder={this.composingLabel(
                  "sportOauthLabel.username",
                  "Username"
                )}
              />
              <input
                type="submit"
                value={this.composingLabel(
                  "sportOauthLabel.checkUsername",
                  "Check Username"
                )}
                className="connectButton"
                onClick={this.handleClick}
              />
            </form>
            <ChangePassword
              oldPassword={this.state.password}
              setNewUserChangePassword={this.setNewUserChangePassword}
              userData={this.state.userWhoWantsToChangePassword}
              passwordChangeRequired={this.state.passwordChangeRequired}
              composingLabel={this.composingLabel}
            />
            <ChangePasswordByUser
              oldPassword={this.state.password}
              setNewUserChangePassword={this.setNewUserChangePassword}
              newUserChangePassword={this.state.newUserChangePassword}
              userData={this.state.userWhoWantsToChangePassword}
              composingLabel={this.composingLabel}
            />
            <ForgottenPassword composingLabel={this.composingLabel} />
          </div>
        </div>
        <img className="emailBackgroudImage" src={background64Image} />
        <img src={logoBottomImage} className="luxTrustMozaikImage" />
        <label className="label-loginEmail">
          {this.state.luxTrustPageLabelBottom}
        </label>
      </div>
    );
  }

  changeValueState() {
    this.setState({
      valueOfGenerateOTP: false,
      labelName: "sportOauthLabel.newOTPSent",
      errorOTP: "",
      code: "",
    });
  }

  renderStageCode() {
    const logoType =
      this.state.imageType !== "" ? this.state.imageType : "jpeg";
    const backgroundType =
      this.state.backgroundImageType !== ""
        ? this.state.backgroundImageType
        : "jpeg";
    const watermarkType =
      this.state.watermarkImageType !== ""
        ? this.state.watermarkImageType
        : "jpeg";
    const logoBottomImageType =
      this.state.logoBottomImageType !== ""
        ? this.state.logoBottomImageType
        : "jpeg";

    const logo64Image = `data:image/${logoType};base64,` + this.state.imageData;
    const background64Image =
      `data:image/${backgroundType};base64,` + this.state.backgroundImage;
    const base64WatermarkImg =
      `data:image/${watermarkType};base64,` + this.state.watermarkImage;
    const logoBottomImage =
      `data:image/${logoBottomImageType};base64,` + this.state.logoBottomImage;
    const showOtpField = this.state.showOtpField;

    return (
      <div
        className="twoFactorAuthenticationContainer"
        style={{ backgroundImage: "url(" + base64WatermarkImg + ")" }}>
        <Modal
          className={
            this.state.loadingCheckOtp === false ? "hidden" : "loaderModal"
          }
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          onRequestClose={this.handleCloseModal}>
          <Loader
            classNameOfLoader={"loaderDefaultStyle"}
            loading={this.state.loadingCheckOtp}
            text={this.composingLabel(
              "sportOauthLabel.checkingOtp",
              "Checking OTP..."
            )}
          />
        </Modal>
        <Modal
          className={
            this.state.loadingSendOtp === false ? "hidden" : "loaderModal"
          }
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          onRequestClose={this.handleCloseModal}>
          <Loader
            classNameOfLoader={"loaderDefaultStyle"}
            loading={this.state.loadingSendOtp}
            text={this.composingLabel(
              "sportOauthLabel.sendingOtp",
              "Sending OTP..."
            )}
          />
        </Modal>

        <img
          src={logo64Image}
          className="luxtrustLogoContainer luxTrustauthenticationImage"
        />
        <ClubRegistrationLanguageComponent
          composingLabel={this.composingLabel}
          handleLanguageChange={this.handleLanguageChange}
        />

        <div className="loginOtp loginSideEmail">
          <p className="loginParagraphEmail">{this.state.error}</p>
          <form onSubmit={this.handleSubmit}>
            <input
              autoFocus={true}
              className="inputFieldEmail"
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange}
              placeholder={this.composingLabel(
                "sportOauthLabel.password",
                "Password"
              )}
            />
            <input
              type="submit"
              value={this.composingLabel("sportOauthLabel.logIn", "Log in")}
              className="connectButton"
            />
          </form>

          {showOtpField === true ? (
            <div>
              <p className="loginParagraphEmail">
                {this.composingLabel(this.state.errorOTP, "")}
              </p>
              <form onSubmit={this.handleSubmitCode}>
                <input
                  className="inputFieldEmail"
                  type="number"
                  name="code"
                  value={this.state.code}
                  onChange={this.handleChange}
                  placeholder={this.composingLabel(
                    "sportOauthLabel.otp",
                    "OTP"
                  )}
                  max={999999}
                  autoComplete="new-password"
                />
                <input
                  type="submit"
                  value={this.composingLabel(
                    "sportOauthLabel.submitCode",
                    "Submit OTP"
                  )}
                  className="connectButton"
                />
              </form>
            </div>
          ) : (
            <div></div>
          )}
          <GenerateNewOTPComponent
            composingLabel={this.composingLabel}
            valueOfGenerateOTP={this.state.valueOfGenerateOTP}
            changeValueState={this.changeValueState}
          />
          <ChangePassword
            oldPassword={this.state.password}
            setNewUserChangePassword={this.setNewUserChangePassword}
            userData={this.state.userWhoWantsToChangePassword}
            passwordChangeRequired={this.state.passwordChangeRequired}
            composingLabel={this.composingLabel}
          />
          <ChangePasswordByUser
            oldPassword={this.state.password}
            setNewUserChangePassword={this.setNewUserChangePassword}
            newUserChangePassword={this.state.newUserChangePassword}
            userData={this.state.userWhoWantsToChangePassword}
            composingLabel={this.composingLabel}
          />
          <ForgottenPassword composingLabel={this.composingLabel} />
        </div>
        <img className="emailBackgroudImage" src={background64Image} />
        <img src={logoBottomImage} className="luxTrustMozaikImage" />
        <label className="label-loginEmail">
          {this.state.luxTrustPageLabelBottom}
        </label>
      </div>
    );
  }
  render() {
    return this.state.stage === 1
      ? this.renderAuthentication()
      : this.renderStageCode();
  }
}
export const LogInMail = () => (
  <div>
    <LoginMailComponent />
  </div>
);

// line 816
// {this.state.reCapchaKey}
// '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'


// WEBPACK FOOTER //
// ./src/main/resources/js/components/LogInMail.js